import Vue from 'vue'
import App from './App'
import store from '@/store'
import router from '@/router'
import Toasted from 'vue-toasted'
import BootstrapVue from 'bootstrap-vue'

// import external components
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ChromePicker from 'vue-color/src/components/Chrome.vue'

// import fontawesome extras
import fontawesome from '@fortawesome/fontawesome'
import { faChevronDown, faCheck, faSearch, faTimesCircle, faChartBar, faTrashAlt, faDownload } from '@fortawesome/fontawesome-free-solid'

// import styles
import '@/styles/_build.scss'

// import directives
import '@/directives/gl-admin-only'
import '@/directives/gl-focus-click'
import '@/directives/gl-focus'
import '@/directives/gl-on-click-away'
import '@/directives/gl-superadmin-only'
import '@/directives/gl-wl'

// import stuff we want to run on init
import '@/filters'
import '@/router/hooks'

// import internal services
import $glAuth from '@/services/$glAuth'
import $glDom from '@/services/$glDom'
import $glEventHub from '@/services/$glEventHub'
import $glForm from '@/services/$glForm'
import $glHttp from '@/services/$glHttp'
import $glRouter from '@/services/$glRouter'
import $glUtil from '@/services/$glUtil'

// import internal components
import Gl404 from '@/components/gl-404.vue'
import GlAlert from '@/components/gl-alert.vue'
import GlAutocomplete from '@/components/gl-autocomplete.vue'
import GlBlankState from '@/components/gl-blank-state.vue'
import GlBtn from '@/components/gl-btn.vue'
import GlColorPicker from '@/components/gl-color-picker.vue'
import GlGroupLogo from '@/components/gl-group-logo.vue'
import GlImgUpload from '@/components/gl-img-upload.vue'
import GlLoadingCard from '@/components/gl-loading-card.vue'
import GlNav from '@/components/gl-nav.vue'
import GlSettingsSidenav from '@/components/gl-settings-sidenav.vue'

// register internal components
Vue.component('gl-404', Gl404)
Vue.component('gl-alert', GlAlert)
Vue.component('gl-autocomplete', GlAutocomplete)
Vue.component('gl-blank-state', GlBlankState)
Vue.component('gl-btn', GlBtn)
Vue.component('gl-color-picker', GlColorPicker)
Vue.component('gl-group-logo', GlGroupLogo)
Vue.component('gl-img-upload', GlImgUpload)
Vue.component('gl-loading-card', GlLoadingCard)
Vue.component('gl-nav', GlNav)
Vue.component('gl-settings-sidenav', GlSettingsSidenav)

// prototype internal services
Vue.prototype.$glAuth = $glAuth
Vue.prototype.$glDom = $glDom
Vue.prototype.$glEventHub = $glEventHub
Vue.prototype.$glForm = $glForm
Vue.prototype.$glHttp = $glHttp
Vue.prototype.$glRouter = $glRouter
Vue.prototype.$glUtil = $glUtil

// register external components
Vue.component('pulse-loader', PulseLoader)
Vue.component('chrome-picker', ChromePicker)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('datepicker', Datepicker)
Vue.component('multiselect', Multiselect)

// use imports
Vue.use(Toasted)
Vue.use(BootstrapVue)

// set production tip/flag
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// register font awesome fonts
fontawesome.library.add(faChevronDown, faCheck, faSearch, faTimesCircle, faChartBar, faTrashAlt, faDownload)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js